import React, { memo } from 'react';
import { Wrapper } from './home.styled';
import Header from '@/components/header/header';
import HomeBg from '@/assets/game-chess/home-bg.png';
import Hero from '@/assets/game-chess/Hero.png';
import Line1 from '@/assets/game-chess/Line.png';
import Line2 from '@/assets/game-chess/line2.png';
import Download from '@/assets/game-chess/download.png';
import Upload from '@/assets/game-chess/upload.png';
import Edit from '@/assets/game-chess/edit.png';
import { Button } from 'antd';
import Game1 from '@/assets/game-chess/Frame 4656455.png';
import Game2 from '@/assets/game-chess/Frame 4656456.png';
import { useNavigate } from 'react-router';
const HomepageComponent = () => {
  const navigate = useNavigate();
  return (
    <Wrapper>
      <div className='absolute top-0 w-full z-[2] flex items-center justify-center'>
        <Header />
      </div>
      <div className='w-full absolute top-0 z-0'>
        <img src={HomeBg} className='w-full' alt='' />
        <img src={Hero} className='w-full' alt='' />
      </div>
      <div className='relative w-full'>
        <div className='relative flex flex-col items-center'>
          <div className='secondary-font font-normal text-[108px] text-center mt-[25%]'>
            Get ready to play, explore, conquer
          </div>
          <div className='w-full mt-[120px]'>
            <img src={Line1} className='w-full' alt='' />
            <div className='w-full flex items-center justify-between px-12'>
              <div className='flex flex-col items-start'>
                <span className='font-medium text-[#B3B3B3] text-[32px]'>Your balance</span>
                <div className='font-medium text-[80px]'>
                  123,456
                  <span className='font-medium text-[32px] text-[#B3B3B3]'>$ARC</span>
                </div>
              </div>
              <div className='flex items-center gap-4'>
                <Button className='withdraw-btn flex items-center justify-center gap-4'>
                  <img src={Download} className='w-10' alt='' />
                  <span className='font-medium text-[24px] text-[#34260F]'>Deposit</span>
                </Button>

                <Button className='deposit-btn flex items-center justify-center gap-4'>
                  <img src={Upload} className='w-10' alt='' />
                  <span className='font-medium text-[24px] text-[#FFFFFF]'>Withdraw</span>
                </Button>
              </div>
            </div>
            <img src={Line2} className='w-full' alt='' />
          </div>
          <div className='w-full mt-40 flex flex-col items-center'>
            <div className='font-normal text-[48px] secondary-font'>GameList</div>
            <div className='text-center font-light text-[24px] text-[#B3B3B3] max-w-[906px]'>
              Explore a variety of exciting games and compete with real players. Show off your skills, climb the
              leaderboard, and win tokens as you play.{' '}
            </div>
            <div className='button-secondary mt-12 flex items-center justify-center gap-4 cursor-pointer'>
              <span className='font-medium text-[32px]'>Bet size:</span>
              <span className='font-medium text-[32px] text-[#FFD139]'>100 $ARC/game</span>
              <img src={Edit} className='w-6' alt='' />
            </div>
            <div className='flex items-center justify-center w-full gap-6 mt-20 mb-20'>
              <div className='flex items-center gap-6 flex-col w-full max-w-[350px]'>
                <img src={Game1} className='w-full' alt='' />
                <span className='font-medium text-[24px]'>Super Chess</span>
                <span className='font-light text-[14px] text-center text-[#B3B3B3]'>
                  PopCraft is an on-chain game with composability for transparent items and ERC-20/DEX integration.
                </span>
                <Button
                  className='play-btn'
                  onClick={() => {
                    navigate('/chess');
                  }}
                >
                  <span className='font-medium text-[24px] text-[#4E3203]'>Play now</span>
                </Button>
              </div>
              <div className='flex items-center gap-6 flex-col  w-full max-w-[350px]'>
                <img src={Game2} className='w-full' alt='' />
                <span className='font-medium text-[24px]'>Rock Paper Scissor</span>
                <span className='font-light text-[14px] text-center text-[#B3B3B3]'>
                  PopCraft is an on-chain game with composability for transparent items and ERC-20/DEX integration.
                </span>
                <Button className='play-btn'>
                  <span className='font-medium text-[24px] text-[#4E3203]'>Play now</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
export const Homepage = memo(HomepageComponent);
